<script>
  import { onMount } from 'svelte';
  let width = 0;
  function calc() {
    const h = document.documentElement;
    const max = h.scrollHeight - h.clientHeight;
    width = max > 0 ? (h.scrollTop / max) * 100 : 0;
  }
  onMount(() => {
    const onScroll = () => requestAnimationFrame(calc);
    calc();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  });
</script>

<div class="scroll-progress" style={`--w:${width}%`}></div>

<style>
  .scroll-progress { position: fixed; left: 0; top: 0; height: 3px; width: var(--w, 0%);
    background: linear-gradient(90deg, var(--emerald), var(--cyan)); z-index: 50;
    box-shadow: 0 0 16px rgba(0,255,198,.6);
  }
</style>

